// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"c94da8e3","583":"e60b56e7","983":"0d880484"}[chunkId] + ".chunk.js";
};